import { Button, Checkbox, Col, Flex, Form, Input, Row, Tag } from "antd";
import Lottie from "lottie-react";
import React, { useState } from "react";
import signInAnimation from "../../../accset/json/signInJson.json";
// import accountService from "../../service/auth"; // ❌ Tạm bỏ nếu không dùng API
import iconLogo from "../../../accset/logoApp.png";
import "./Sign.scss";
import { openNotification } from "../../global/item/Notification/Notification";
import { useTranslation } from "react-i18next";
import Loading from "../../global/item/Loading/loading";
import { InfoCircleOutlined } from "@ant-design/icons";

interface SignInProps {
  onLoginSuccess: () => void;
}

function SignIn({ onLoginSuccess }: SignInProps) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const onFinish = async (values: any) => {
    const { username, password } = values;
    console.log("loginData", { username, password });

    setLoading(true);

    // 🔹 Giả lập quá trình kiểm tra đăng nhập
    setTimeout(() => {
      if (username === "adminDemoWeb" && password === "demo@123") {
        // 🔹 Tự tạo token giả lập
        const fakeToken = "token_" + Math.random().toString(36).substring(2);
        localStorage.setItem("token", fakeToken);
        console.log("✅ Fake token created:", fakeToken);

        openNotification({
          type: "success",
          message: t("login.success") || "Login successful",
          description: t("login.messSuccess") || "Welcome back!",
        });

        onLoginSuccess(); // báo về App.tsx để chuyển trang
      } else {
        openNotification({
          type: "error",
          message: t("login.failure") || "Login failed",
          description:
            t("login.mesFailure") || "Invalid username or password!",
        });
      }
      setLoading(false);
    }, 1000);
  };

  const initialValues = {
    username: "adminDemoWeb",
    password: "demo@123",
  };

  return (
    <div>
      {loading ? (
        <Loading />
      ) : (
        <div style={{ background: "#f2f2f2" }}>
          <Row>
            <Col xl={16}>
              <div
                style={{
                  height: "50px",
                  borderRadius: "10px",
                  margin: "10px 4px",
                }}
              >
                <div
                  style={{
                    marginLeft: 20,
                    height: "100%",
                    background: `url(${iconLogo}) no-repeat left center`,
                  }}
                ></div>
              </div>
              <Lottie
                animationData={signInAnimation}
                style={{ width: 650, margin: "0 auto" }}
              />
            </Col>

            <Col xl={8} className="signInRight">
              <h2 className="signInRight--title">Welcome</h2>
              <p className="signInRight--desc">Sign in to your account</p>

              <Tag
                style={{
                  height: 46,
                  marginBottom: 32,
                  border: "none",
                  background: "#CAFDF5",
                  borderRadius: 8,
                  fontSize: 14,
                }}
              >
                <Flex
                  align="center"
                  justify="center"
                  style={{ height: "100%", gap: 8 }}
                >
                  <InfoCircleOutlined
                    style={{
                      fontSize: 16,
                      color: `var(--primary-color)`,
                      paddingLeft: 20,
                    }}
                  />
                  <span style={{ paddingRight: 20 }}>
                    Use Username <strong>adminDemoWeb</strong> with Password{" "}
                    <strong>demo@123</strong>
                  </span>
                </Flex>
              </Tag>

              <Form
                name="basic"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                initialValues={initialValues}
                onFinish={onFinish}
                autoComplete="off"
              >
                <Form.Item
                  className="formItem"
                  name="username"
                  rules={[{ required: true, message: "Please input your username!" }]}
                >
                  <div className="form-field">
                    <Input className="form-input" placeholder=" " />
                    <label htmlFor="username" className="form-label">
                      Username
                    </label>
                  </div>
                </Form.Item>

                <Form.Item
                  name="password"
                  rules={[{ required: true, message: "Please input your password!" }]}
                >
                  <div className="form-field">
                    <Input.Password className="form-input" placeholder=" " />
                    <label htmlFor="password" className="form-label">
                      Password
                    </label>
                  </div>
                </Form.Item>

                <Form.Item name="remember" valuePropName="checked">
                  <Checkbox>Remember me</Checkbox>
                </Form.Item>

                <Button
                  type="primary"
                  htmlType="submit"
                  style={{
                    width: "100%",
                    height: 46,
                    marginTop: 16,
                    fontWeight: 600,
                  }}
                >
                  Sign in
                </Button>
              </Form>
            </Col>
          </Row>
        </div>
      )}
    </div>
  );
}

export default SignIn;
